import { Component, OnInit, ElementRef, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../../validations/date-text-field.validator'
import { DrugPlan } from '../../models/drug-plan'
import { PlanList } from '../../models/plan-list'
import { Notes } from '../../models/notes'
import { EnrollmentElectionType } from '../../models/enrollment-election-type'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { BeneficiaryInfo } from '../../models/enrollments'
import { Step2Model } from '../../models/Step2Model'
import { AddressDB } from '../../../user-management/models/address'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { LicenseApptGateway } from '../../../user-management/gateways/license-appt-gateway'
import { License } from '../../../user-management/models/license-details'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { PaymentAccount } from '../../models/payment-account'
import { PortalGlobals } from '../../../portalglobals'
import { stcobModel } from '../../models/stcob-model'
import { ValidatedSelectOptionModel } from '../../../validations/validated-dropdown.component'
import { PaymentOption, PaymentOptions } from '../../models/payment-options'
import { isMMDDYYYY } from '../../../../app/validations/is-mmddyyyy'
import * as moment from 'moment'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { EnrollmentField, EnrollmentFieldCodes } from '../../models/enrollment-field'
import { ExternalEnrollmentFieldCodes } from '../../models/ExternalEnrollmentFieldCodes'
import { EnrollmentHeader } from '../../models/EnrollmentHeader'
import { DatePipe } from '@angular/common'
import { isPoBox } from '../../../utils/is-po-box'
import { GetEnrollmentDataResponse, GetEnrollmentDataByID } from '../../models/get-enrollment-data-response'
import { EnrollmentCacheData } from '../../models/EnrollmentCacheData'
import { PrescriptionDrug } from '../common/prescription-drug-component'
import { AlphaNumericFieldValidator } from '../../../validations/alpha-numeric-field-validator'
import { RaceEthnicityComponent } from '../common/race-ethnicity.component'
import { AccessibilityComponent } from '../common/accessibility.component'
@Component({
    templateUrl: './external-agent-enrollment.component.html',
    providers: [DatePipe]
})
export class ExternalAgentEnrollmentComponent implements OnInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    enrollmentCacheData: EnrollmentCacheData = {} as EnrollmentCacheData
    getEnrollmentDataResponse: GetEnrollmentDataResponse = new GetEnrollmentDataResponse()
    notBlankValidator = new NotBlankGenericFieldValidator()
    validatedDate = new DateTextFieldValidator()
    alphanumericValidator: AlphaNumericFieldValidator = new AlphaNumericFieldValidator()
    drugPlanModel = {} as DrugPlan
    notesModel = {} as Notes
    isValidAgent = false as boolean
    electionperiod = '' as string
    planList = [] as PlanList[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    orgID = '9'
    selectedElectionPeriod = '' as string
    paymentMethod: typeof PaymentOptions
    step2Model: Step2Model
    reasonCode = ''
    periodSelected = ''
    dateField: boolean
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    ErrorMessages: any[]
    hasError: boolean
    hasIncompleteError: boolean
    states: State[] = [] as State[]
    userProfileID: number = 0
    disabled: boolean = false
    mailingAddressValid: boolean = false
    mailingCityValid: boolean = false
    mailingStateValid: boolean = false
    showSTCOBFields: boolean = false
    showGroupDetails: boolean = false
    isSingleGroup: boolean = false
    isExternalAgentEnrl:boolean = true
    Carrier: string
    Account: string
    Group: string
    stcobDetails: stcobModel[]
    groupName: ValidatedSelectOptionModel[] = []
    SelectedGroupDetail: stcobModel[]
    carrierInfo: string
    accountInfo: string
    groupInfo: string
    creditOptions: ValidatedRadioButtonModel[]
    enrollmentHeader: EnrollmentHeader = {} as EnrollmentHeader
    public loading: boolean
    showOtherCoverage: boolean
    SEPReasonCodeList: any[]
    effDate: Date
    rdDisCancel: ValidatedRadioButtonModel[] = []
    IsDisEnrllYES: boolean
    disEnrllReasonCode: ValidatedSelectOptionModel[] = []
    disEnrllType: ValidatedSelectOptionModel[] = []
    PaperlessOption: boolean
    public rdBtnEOB: ValidatedRadioButtonModel[] = []
    emailLabel: string
    eobNotRequired: string
    public isEOB: boolean
    accessibilityValue: string
    private accessibilityComponent: AccessibilityComponent
    //@ViewChild('myGrid') myGrid: jqxGridComponent;
    //@ViewChild('myDropDownButton') myDropDownButton: jqxDropDownButtonComponent;
    @ViewChild('focusableEleTop', { static: true }) focusableEleTop: ElementRef
    @ViewChild('prescripitionDrug', { static: true }) prescripitionDrug: PrescriptionDrug
    @ViewChild('accessibility') accessibility: AccessibilityComponent

    electionPeriodsList: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]

    benefitaryModel: BeneficiaryInfo = {} as BeneficiaryInfo
    paymentOption: string = ''
    paymentAccount: PaymentAccount = {} as PaymentAccount
    disenrllType: string

    constructor(
        private router: Router,
        private _enrollementGateway: EnrollmentGateway,
        protected formValidationService: FormValidationService,
        private _userAccessGateway: UserAccessGateway,
        private _licenseAppGateway: LicenseApptGateway,
        private _stateGateway: StateGateway,
        public _global: PortalGlobals,
        private pipe: DatePipe
    ) {
        this.step2Model = {} as Step2Model
        this.step2Model.notes = {} as Notes
        this.step2Model.prescriptionDrug = {} as DrugPlan
        this.step2Model.beneficiaryInfo = {} as BeneficiaryInfo
        this.paymentMethod = {} as typeof PaymentOptions
        this.ErrorMessages = [] as any[]
        this.showOtherCoverage = false
        this.SEPReasonCodeList = [] as any[]
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollementGateway)
        // this.accessibilityComponent = new AccessibilityComponent(this._enrollementGateway);
    }

    ShowDisCancelEnrll(SelDis: any) {
        if (SelDis === 'Y') {
            this.IsDisEnrllYES = true
        }
        if (SelDis === 'N') {
            this.IsDisEnrllYES = false
        }
        this.enrollmentViewModel.DISENROLLIND = SelDis
    }

    ngOnInit() {
        this.eobOptionChanged
        var User = localStorage.getItem('UserSessionContext')!
        this._global.currentUser = JSON.parse(User)

        this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModel()

        if (this.enrollmentViewModel === null || this.enrollmentViewModel === undefined) {
            this.goBack()
        }

        if (this.enrollmentViewModel.ISSINGLEGROUP == true) {
            this.isSingleGroup = true
            this.enrollmentViewModel.ELECTION = 'Special'
            this.enrollmentViewModel.SEPREASONCD = 201
            this.enrollmentViewModel.SEPREASONTEXT = 'I am leaving/losing/joining employer or union coverage. My coverage changed or will change on'
        }
        if (
            this.enrollmentViewModel.DISENROLLREASONCD !== undefined &&
            this.enrollmentViewModel.DISENROLLREASONCD !== null &&
            this.enrollmentViewModel.DISENROLLREASONCD !== ''
        ) {
            this.DisEnrllReasonCode(this.enrollmentViewModel.DISENROLLREASONCD)
        }

        if (this.enrollmentViewModel.AGENTID === null || this.enrollmentViewModel.AGENTID === undefined || this.enrollmentViewModel.AGENTID === '') {
            if (sessionStorage.getItem('EnrollmentCache') != null) {
                this.enrollmentCacheData = JSON.parse(sessionStorage.getItem('EnrollmentCache')!)

                //this.getEnrollmentDataResponse = this._enrollementGateway.getEnrollmentDataByKey(this.EnrollmentKey)

                this.loading = true

                if (
                    this.enrollmentCacheData.EnrollmentKey === null ||
                    this.enrollmentCacheData.EnrollmentKey === undefined ||
                    this.enrollmentCacheData.EnrollmentKey === ''
                ) {
                    this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                    this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                    this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                    this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                    this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                    this.enrollmentViewModel.ACCESSKEY = this.enrollmentCacheData.ACCESSKEY
                    this.enrollmentViewModel.ENROLLMENTID = this.enrollmentCacheData.ENROLLMENTID
                    this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                    this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                    this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                    this.enrollmentViewModel.ISSINGLEGROUP = this.enrollmentCacheData.ISSINGLEGROUP
                    this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                    this.goBack()
                } else {
                    this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                    this.enrollmentViewModel.ISSINGLEGROUP = this.enrollmentCacheData.ISSINGLEGROUP
                    this._enrollementGateway.getEnrollmentDataByKey(this.enrollmentCacheData.EnrollmentKey).subscribe(
                        (getEnrollmentDataResponse: GetEnrollmentDataResponse) => {
                            this.enrollmentViewModel.ENROLLKEY = this.enrollmentCacheData.EnrollmentKey
                            this.enrollmentViewModel.ADMINID = this.enrollmentCacheData.AdminID
                            this.enrollmentViewModel.AGENTORGID = this.enrollmentCacheData.AgentOrgID
                            this.enrollmentViewModel.AGENTNAME = this.enrollmentCacheData.AgentName
                            this.enrollmentViewModel.PLANTYPENAME = this.enrollmentCacheData.PLANTYPENAME
                            this.enrollmentViewModel.USERNAME = this.enrollmentCacheData.USERNAME
                            this.enrollmentViewModel.ACCESSKEY = this.enrollmentCacheData.ACCESSKEY
                            this.enrollmentViewModel.ENROLLMENTID = this.enrollmentCacheData.ENROLLMENTID
                            this._global.selectedPlanYear = this.enrollmentCacheData.PlanYear
                            this.enrollmentViewModel.FORMNAME = this.enrollmentCacheData.FORMNAME
                            this.enrollmentViewModel.SEPREASONTEXT = this.enrollmentCacheData.SEPREASONTEXT
                            this.enrollmentViewModel.PaperlessSettings = this.enrollmentCacheData.PaperlessSettings

                            this.enrollmentViewModel = this._enrollementGateway.getEnrollmentViewModelByKey(getEnrollmentDataResponse)
                            if (this.enrollmentViewModel.ISSINGLEGROUP == true) {
                                this.isSingleGroup = true
                                this.enrollmentViewModel.ELECTION = 'Special'
                                this.enrollmentViewModel.SEPREASONCD = 201
                                this.enrollmentViewModel.SEPREASONTEXT =
                                    'I am leaving/losing/joining employer or union coverage. My coverage changed or will change on'
                                this.enrollmentViewModel.SINGLEGRPNAME = this.enrollmentCacheData.SINGLEGRPNAME
                                this.enrollmentViewModel.ISSTCOB = this.enrollmentCacheData.ISSTCOB
                            } else {
                                this.enrollmentViewModel.ISEXTERNALAGENT = true
                            }
                            if (
                                this.enrollmentViewModel.DISENROLLREASONCD !== undefined &&
                                this.enrollmentViewModel.DISENROLLREASONCD !== null &&
                                this.enrollmentViewModel.DISENROLLREASONCD !== ''
                            ) {
                                this.DisEnrllReasonCode(this.enrollmentViewModel.DISENROLLREASONCD)
                            }
                            this.LoadData()
                            this.ShowDisCancelEnrll(this.enrollmentViewModel.DISENROLLIND)

                            this.paymentOption = this.enrollmentViewModel.PWO
                            this.prescripitionDrug.toggle(this.enrollmentViewModel.OTHCVRG, 'OTHCVRG')

                            this.loading = false
                        },
                        (err) => {
                            this.loading = false
                        }
                    )
                }
            } else {
                this.goBack()
            }
        } else {
            this.LoadData()
        }

        if (!this.enrollmentViewModel.ISSINGLEGROUP === true) {
            this._enrollementGateway.getPaperlessSetting('SSIExternalAgentPaperlessSetting').subscribe((data) => {
                this.PaperlessOption = data
                this.enrollmentViewModel.PaperlessSettings = data

                if (this.PaperlessOption) {
                    this.emailLabel = 'Email Address (Required for Paperless)'
                    this.rdBtnEOB.push(
                        { value: 'EEOB', htmlLabel: 'Yes, I want to go paperless for all available and future documents' },
                        { value: 'PEOB', htmlLabel: 'No, I want to receive all my documents in the mail' }
                    )
                    // if (this.enrollmentViewModel.EOB === 'EEOB')
                    this.setAccessibility(this.enrollmentViewModel.EOB)
                    if (
                        this.enrollmentViewModel.EOB != undefined &&
                        this.enrollmentViewModel.EOB != null &&
                        this.enrollmentViewModel.EOB != '' &&
                        (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '9')
                    ) {
                        this.enrollmentViewModel.EOB = 'EEOB'
                        this.isEOB = true
                    } else {
                        this.enrollmentViewModel.EOB = 'PEOB'
                        this.isEOB = false
                    }

                    this.eobCheckOptionChanged(this.enrollmentViewModel.EOB === 'EEOB')
                } else {
                    this.emailLabel = 'Email Address (optional)'
                    this.rdBtnEOB.push(
                        { value: 'EEOB', htmlLabel: 'Yes, I want to receive my EOB statements electronically' },
                        { value: 'PEOB', htmlLabel: 'No, I want to receive my EOB statements in the mail' }
                    )
                }
            })
        } else {
            this._enrollementGateway.getPaperlessSetting('SSISingleGroupPaperlessSetting').subscribe((data) => {
                this.PaperlessOption = data
                this.enrollmentViewModel.PaperlessSettings = data

                if (this.PaperlessOption) {
                    this.emailLabel = 'Email Address (Required for Paperless)'

                    this.setAccessibility(this.enrollmentViewModel.EOB)
                    if (
                        this.enrollmentViewModel.EOB != undefined &&
                        this.enrollmentViewModel.EOB != null &&
                        this.enrollmentViewModel.EOB != '' &&
                        (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                            this.enrollmentViewModel.EOB.toLowerCase() === '9')
                    ) {
                        this.enrollmentViewModel.EOB = 'EEOB'
                        this.isEOB = true
                    } else {
                        this.enrollmentViewModel.EOB = 'PEOB'
                        this.isEOB = false
                    }

                    this.eobCheckOptionChanged(this.enrollmentViewModel.EOB === 'EEOB')
                }
            })
        }
    }

    eobCheckOptionChanged(option: boolean) {
        if (option === true) {
            this.enrollmentViewModel.EOB = 'EEOB'
            this.isEOB = true
            this.emailLabel = 'Email Address (Required for Paperless)'
        } else {
            this.isEOB = false
            this.enrollmentViewModel.EOB = 'PEOB'
            this.emailLabel = 'Email Address (Optional)'
        }
    }

    eobOptionChanged(option: string) {
        if (!this.PaperlessOption) {
            if (option === 'EEOB') {
                this.emailLabel = 'Email Address'
            } else {
                this.emailLabel = 'Email Address (optional)'
            }
        }
        this.enrollmentViewModel.EOB = option
    }

    LoadData(): void {
        this.creditOptions = [
            {
                htmlLabel: 'Yes',
                value: 'Yes'
            },
            {
                htmlLabel: 'No',
                value: 'No'
            }
        ]

        this.electionPeriodsList = [
            {
                value: 'Special',
                htmlLabel: 'Special'
            }
        ]
        this.accessibilityValue = this.enrollmentViewModel.EOB
        this.enrollmentViewModel.ISBACK = false
        if (this.enrollmentViewModel.ISEXTERNALAGENT) {
            this.setExternalData()
        } else {
            this.setData()
        }
        if (this.mailingAddress !== undefined && this.mailingAddress.state === undefined) {
            this.mailingAddress.state = '0'
        } else if (this.mailingAddress.state === '') {
            this.mailingAddress.state = '0'
        }
        if (this.residentialAddress !== undefined && this.residentialAddress.state === undefined) {
            this.residentialAddress.state = '0'
        } else if (this.residentialAddress.state === '') {
            this.residentialAddress.state = '0'
        }
    }

    setExternalData() {
        this.getAllStates()
    }

    getAllStates() {
        if (this.states !== undefined && this.states.length > 0) {
            this.setExternState()
        } else {
            this._stateGateway.getAllStates().subscribe((state) => {
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }
                this.setExternState()
            })
        }
    }

    setExternState() {
        this.setExternData()
    }

    setExternData() {
        this.setData()
        this.residentialAddress = this.enrollmentViewModel.residentialAddress
        this.mailingAddress = this.enrollmentViewModel.mailingAddress
        console.log(this.enrollmentViewModel)
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }

    setData() {
        if (!this.enrollmentViewModel.ISEXTERNALAGENT) {
            if (this.enrollmentViewModel.residentialAddress !== undefined) this.residentialAddress = this.enrollmentViewModel.residentialAddress
            if (this.enrollmentViewModel.mailingAddress !== undefined) this.mailingAddress = this.enrollmentViewModel.mailingAddress
        }
        if (this.enrollmentViewModel.ISSINGLEGROUP == true) {
            this._stateGateway.getAllStates().subscribe((state) => {
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }
                this.states.unshift({ value: 0, text: '-- Choose One --' })
                this.showSTCOBFields = this.enrollmentViewModel.ISSINGLEGROUP && this.enrollmentViewModel.ISSTCOB
                this.paymentOption = this.enrollmentViewModel.PWO = 'Direct Bill'

                if (this.enrollmentViewModel.POVERIND !== undefined && this.enrollmentViewModel.POVERIND === '1') {
                    this.residentialAddress.poboxoverride = true
                } else {
                    this.residentialAddress.poboxoverride = false
                }
            })

            this.rdDisCancel.push({ value: 'Y', htmlLabel: 'Yes' }, { value: 'N', htmlLabel: 'No' })

            this._enrollementGateway.getDisEnrollmentReasonCodes().subscribe((disenrllReasonCode) => {
                this.disEnrllReasonCode = []
                for (let i = 0; i < disenrllReasonCode.length; i++) {
                    this.disEnrllReasonCode.push({ value: disenrllReasonCode[i].value, text: disenrllReasonCode[i].text })
                }
                this.disEnrllReasonCode.unshift({ value: 0, text: '-- Choose One --' })
            })

            this.ShowDisCancelEnrll(this.enrollmentViewModel.DISENROLLIND)
        } else {
            this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this.enrollmentViewModel.AGENTNAME).subscribe((state) => {
                this.states = []
                for (let i = 0; i < state.length; i++) {
                    this.states.push({ value: state[i].value, text: state[i].text })
                }

                if (this.states.length === 0) {
                    //IF agreemtnver=40 agent and not hv license than get all states
                    if (sessionStorage.getItem('SkipGSCheck') !== undefined) {
                        var skipGS = String(sessionStorage.getItem('SkipGSCheck'))

                        if (skipGS === 'Yes') {
                            this._stateGateway.getAllStates().subscribe((state) => {
                                for (let i = 0; i < state.length; i++) {
                                    this.states.push({ value: state[i].value, text: state[i].text })
                                }
                            })
                        }
                    }
                }

                this.states.unshift({ value: 0, text: '-- Choose One --' })

                this.showSTCOBFields = this.enrollmentViewModel.ISSINGLEGROUP && this.enrollmentViewModel.ISSTCOB
                this.enrollmentViewModel.POVERIND = '0'
            })
        }

        this.hasError = false
    }

    DisEnrllReasonCode(event: any) {
        this.enrollmentViewModel.DISENROLLREASONCD = event

        if (this.enrollmentViewModel.DISENROLLREASONCD === '810') {
            this.enrollmentViewModel.DISENROLLTYPE = 'V'
            this.disenrllType = 'Voluntary'
        } else if (
            this.enrollmentViewModel.DISENROLLREASONCD === '807' ||
            this.enrollmentViewModel.DISENROLLREASONCD === '853' ||
            this.enrollmentViewModel.DISENROLLREASONCD === '854'
        ) {
            this.enrollmentViewModel.DISENROLLTYPE = 'I'
            this.disenrllType = 'Involuntary'
        } else {
            this.enrollmentViewModel.DISENROLLTYPE = ''
            this.disenrllType = ''
        }
    }

    periodSelectdChanged(period: string) {
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()
        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                else this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), 0, 1)
            }
        } else {
            if (this.enrollmentViewModel.ENROLLKEY === undefined || this.enrollmentViewModel.ENROLLKEY === '') {
                if (currDate.getMonth() == 11) {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                } else {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
                }

                //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
                if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                    if (this.enrollmentViewModel.EFFDT.getFullYear() !== this._global.selectedPlanYear) {
                        if (this._global.selectedPlanYear > currDate.getFullYear())
                            this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                    }
                }
            }
        }
    }
    reasonCodeChanged(SelReasonCode: any) {
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }

    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }

    change(enrollment: BeneficiaryInfo) {
        this.enrollmentViewModel.beneficiaryInfo = enrollment
        this.enrollmentViewModel.HICN = enrollment.medicareId
        this.enrollmentViewModel.APPFN = enrollment.firstName
        this.enrollmentViewModel.APPLN = enrollment.lastName
        this.enrollmentViewModel.APPDOB = enrollment.dateOfBirth
        this.enrollmentViewModel.CELLPHONE = enrollment.cellPhone || ''
        this.enrollmentViewModel.APPGEN = enrollment.gender
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.MEDA = enrollment.medicarePartAEffectiveDate
        this.enrollmentViewModel.MEDB = enrollment.medicarePartBEffectiveDate
        this.enrollmentViewModel.SUFFIX = enrollment.suffixName || ''
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.TITLE = enrollment.title
        this.enrollmentViewModel.APPPHONE = enrollment.primaryPhone || ''
    }

    // Payment Options
    paymentOptionChanged(option: string) {
        this.paymentOption = this.enrollmentViewModel.PWO = option
    }

    setSTCOBData(row: any) {
        this.Carrier = 'Carrier'
        this.Group = 'Group'
        this.Account = 'Account'
        this.showGroupDetails = true
        this.enrollmentViewModel.STCOBGROUPNAME = row['GroupName']
        this.enrollmentViewModel.GROUP = row['Group']
        this.enrollmentViewModel.CARRIER = row['Carrier']
        this.enrollmentViewModel.ACCOUNT = row['Account']
    }

    paymentAccountChanged(paymentAccount: PaymentAccount) {
        this.paymentAccount = this.enrollmentViewModel.paymentAccount = paymentAccount
        this.enrollmentViewModel.ACCHOLDERNAME = paymentAccount.holderName
        this.enrollmentViewModel.ROUTINGNB = paymentAccount.routingNumber
        this.enrollmentViewModel.ACCOUNTNB = paymentAccount.number
        this.enrollmentViewModel.FININSTNAME = paymentAccount.institution
        this.enrollmentViewModel.EFTTYPE = paymentAccount.type
    }

    onSubmit(): void {
        this.isValidAgent = true
    }

    formSubmit(): void {
        this.ErrorMessages = [] as any[]
        this.hasError = false
        this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
        this.enrollmentViewModel.STEPCODE = '2'

        this.enrollmentViewModel.PLANYEAR = String(this._global.selectedPlanYear)
        if (this.enrollmentViewModel.OTHCVRG !== null && this.enrollmentViewModel.OTHCVRG !== undefined) {
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
        }

        if (this.isEOB) {
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.EOB = 'PEOB'
        }

        // Set  Access
        if (!this.enrollmentViewModel.ISSINGLEGROUP) {
            this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)
        } else {
            this.enrollmentViewModel.EOB = this.enrollmentViewModel.accessibility
        }
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        if (this.enrollmentViewModel.mailingAddress !== undefined) {
            this.enrollmentViewModel.MAILADD1 = this.enrollmentViewModel.mailingAddress.addressLine1
            this.enrollmentViewModel.MAILADD2 = this.enrollmentViewModel.mailingAddress.addressLine2
            this.enrollmentViewModel.MAILCITY = this.enrollmentViewModel.mailingAddress.city
            this.enrollmentViewModel.MAILST = this.enrollmentViewModel.mailingAddress.state
            this.enrollmentViewModel.MAILZIP = this.enrollmentViewModel.mailingAddress.zip
        }

        if (this.enrollmentViewModel.residentialAddress !== undefined) {
            // this.mailingAddress = this.enrollmentViewModel.mailingAddress
            this.enrollmentViewModel.APPADD1 = this.enrollmentViewModel.residentialAddress.addressLine1
            this.enrollmentViewModel.APPADD2 = this.enrollmentViewModel.residentialAddress.addressLine2
            this.enrollmentViewModel.APPCITY = this.enrollmentViewModel.residentialAddress.city
            this.enrollmentViewModel.APPST = this.enrollmentViewModel.residentialAddress.state
            this.enrollmentViewModel.APPZIP = this.enrollmentViewModel.residentialAddress.zip
        }

        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }

        if (this.enrollmentViewModel.DISENROLLIND === 'N') {
            this.enrollmentViewModel.DISENROLLNOTICEDT = ''
            this.enrollmentViewModel.DISENROLLREASONCD = ''
            this.enrollmentViewModel.DISENROLLTYPE = ''
            this.enrollmentViewModel.DISENROLLDATE = ''
        }
        if (!this.enrollmentViewModel.ISSINGLEGROUP) {
            this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
            this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)

            this.enrollmentViewModel.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(
                this.enrollmentViewModel.selectedEthnicity
            )
            this.enrollmentViewModel.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollmentViewModel.selecteRace)
        }
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (!this.isFormInvalid()) {
            this.loading = true
            let mailStateCode = this.enrollmentViewModel.MAILST
            let mailZip = this.enrollmentViewModel.MAILZIP
            if (this.enrollmentViewModel.SAMEADDRESS) {
                mailStateCode = '0'
                mailZip = '0'
            }
            this._enrollementGateway.validateZip(this.enrollmentViewModel.APPST, this.enrollmentViewModel.APPZIP, mailStateCode, mailZip).subscribe(
                (model: string[]) => {
                    if (model !== undefined && model !== null && model.length !== 0) {
                        this.ErrorMessages = model
                        console.log(this.ErrorMessages)
                        this.hasError = true
                        window.scrollTo(0, 0)
                        this.loading = false
                    } else {
                        this._enrollementGateway.CheckDuplicateEnrollment(this.enrollmentViewModel).subscribe(
                            (model: string[]) => {
                                if (model !== undefined && model !== null && model.length !== 0) {
                                    this.ErrorMessages = model
                                    this.hasError = true
                                    this.focusableEleTop.nativeElement.focus()
                                    this.loading = false
                                } else {
                                    this._enrollementGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                        (model: SubmitEnrollmentDataResponse) => {
                                            let response = model

                                            if (response !== undefined) {
                                                if (
                                                    this.enrollmentViewModel.FORMNAME === 'EXTERNAL' ||
                                                    this.enrollmentViewModel.FORMNAME === 'EXTERNALSMS'
                                                ) {
                                                    for (let i = 0; i < response.Errors.length; i++) {
                                                        if (
                                                            response.Errors[i].FieldCode === 'APPDT' ||
                                                            response.Errors[i].FieldCode === '4028' ||
                                                            response.Errors[i].FieldCode === '4029' ||
                                                            response.Errors[i].FieldCode === 'ELECTION'
                                                        ) {
                                                            response.Errors.splice(i, 1)
                                                            i--
                                                        }
                                                    }
                                                }
                                                if (response.Errors !== undefined && response.Errors.length > 0) {
                                                    this.hasError = false
                                                    for (let i = 0; i < response.Errors.length; i++) {
                                                        this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                    }
                                                    this.hasError = true
                                                    this.focusableEleTop.nativeElement.focus()
                                                } else {
                                                    if (
                                                        response.EnrollmentKey !== undefined &&
                                                        response.EnrollmentKey !== '' &&
                                                        response.EnrollmentKey !== null
                                                    ) {
                                                        this.enrollmentViewModel.ENROLLKEY = response.EnrollmentKey

                                                        if (this.enrollmentViewModel.FORMNAME === 'SINGLEGROUP') {
                                                            this.enrollmentViewModel.ISSINGLEGROUP = true
                                                        }

                                                        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                                                        this.loading = false

                                                        this.enrollmentCacheData.EnrollmentKey = response.EnrollmentKey
                                                        this.enrollmentCacheData.AgentName = this.enrollmentViewModel.AGENTNAME
                                                        this.enrollmentCacheData.AgentID = this.enrollmentViewModel.AGENTID
                                                        this.enrollmentCacheData.AdminID = this.enrollmentViewModel.ADMINID
                                                        this.enrollmentCacheData.AgentOrgID = this.enrollmentViewModel.AGENTORGID
                                                        this.enrollmentCacheData.PLANTYPENAME = this.enrollmentViewModel.PLANTYPENAME
                                                        this.enrollmentCacheData.USERNAME = this.enrollmentViewModel.USERNAME
                                                        this.enrollmentCacheData.ACCESSKEY = this.enrollmentViewModel.ACCESSKEY
                                                        this.enrollmentCacheData.ENROLLMENTID = this.enrollmentViewModel.ENROLLMENTID
                                                        this.enrollmentCacheData.PlanYear = this._global.selectedPlanYear
                                                        this.enrollmentCacheData.FORMNAME = this.enrollmentViewModel.FORMNAME
                                                        if (this.enrollmentViewModel.FORMNAME === 'SINGLEGROUP') {
                                                            this.enrollmentCacheData.ISSINGLEGROUP = true
                                                            this.enrollmentCacheData.ISSTCOB = this.enrollmentViewModel.ISSTCOB
                                                            this.enrollmentCacheData.SINGLEGRPNAME = this.enrollmentViewModel.SINGLEGRPNAME
                                                        }
                                                        this.enrollmentCacheData.SEPREASONTEXT = this.enrollmentViewModel.SEPREASONTEXT
                                                        this.enrollmentCacheData.PaperlessSettings = this.enrollmentViewModel.PaperlessSettings

                                                        sessionStorage.setItem('EnrollmentCache', JSON.stringify(this.enrollmentCacheData))

                                                        this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step3'])
                                                    } else {
                                                        this.ErrorMessages.push('Error while submitting data, please try again.')
                                                        this.hasError = true
                                                        this.focusableEleTop.nativeElement.focus()
                                                    }
                                                }
                                            } else {
                                                this.ErrorMessages.push('Error while submitting data, please try again.')
                                                this.hasError = true
                                                this.focusableEleTop.nativeElement.focus()
                                            }
                                            this.loading = false
                                        },
                                        (err) => {
                                            this.loading = false
                                        }
                                    )
                                }
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            window.scrollTo(0, 0)
        }
    }
    setAccessibility(lAccessibility) {
        if (this.accessibilityValue != '' && this.accessibilityValue != undefined) {
            lAccessibility = this.accessibilityValue
        }
        if (lAccessibility == '1' || lAccessibility == '5') {
            // this.accessibilityValue = "1";
            this.enrollmentViewModel.accessibility = '1'
        }
        if (lAccessibility == '2' || lAccessibility == '6') {
            // this.accessibilityValue = "2";
            this.enrollmentViewModel.accessibility = '2'
        }
        if (lAccessibility == '4' || lAccessibility == '7') {
            //  this.accessibilityValue = "4";
            this.enrollmentViewModel.accessibility = '4'
        }
        if (lAccessibility == '8' || lAccessibility == '9') {
            //  this.accessibilityValue = "4";
            this.enrollmentViewModel.accessibility = '8'
        }
        this.accessibilityValue = this.enrollmentViewModel.accessibility
    }

    SetLanFormat(eob: string, selecteAccessibility: string): string {
        // Set  Access
        this.accessibilityValue = selecteAccessibility

        if (eob == 'EEOB' || eob == 'PEOB') {
            if (this.accessibilityValue != undefined && this.accessibilityValue != '') {
                if (this.accessibilityValue == '1') {
                    if (eob == 'EEOB') {
                        eob = '5'
                    } else {
                        eob = '1'
                    }
                }
                if (this.accessibilityValue == '2') {
                    if (eob == 'EEOB') {
                        eob = '6'
                    } else {
                        eob = '2'
                    }
                }
                if (this.accessibilityValue == '4') {
                    if (eob == 'EEOB') {
                        eob = '7'
                    } else {
                        eob = '4'
                    }
                }
                if (this.accessibilityValue == '8') {
                    if (eob == 'EEOB') {
                        eob = '9'
                    } else {
                        eob = '8'
                    }
                }
            }
        }
        return eob
    }
    resetBankDeatils() {
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCOUNTNB = ''

        this.paymentAccount.holderName = ''
        this.paymentAccount.institution = ''
        this.paymentAccount.number = ''
        this.paymentAccount.routingNumber = ''
        this.paymentAccount.type = null
        this.paymentAccount = {} as PaymentAccount
        this.enrollmentViewModel.paymentAccount = this.paymentAccount
    }
    isFormInvalid(): boolean {
        this.hasError = false

        if (this.enrollmentViewModel.ELECTION !== undefined) {
            if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }
        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '') {
            this.ErrorMessages.push('Street Address is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '') {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }
        //    let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
        //    if (!isCityValid) {
        //        this.hasError = true
        //        this.ErrorMessages.push('Please enter valid City')
        //    }
        //}
        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        } else {
            let regexCityVal = /^[A-Za-z\s\-.]+$/

            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }
        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '') {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '') {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')

            if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else {
                if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                    this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '') {
            this.ErrorMessages.push('Sex is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.FORMNAME !== 'EXTERNAL' && this.enrollmentViewModel.FORMNAME !== 'EXTERNALSMS') {
            if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
                this.ErrorMessages.push('Application Date is required')
                this.hasError = true
            }
        } else {
            if (this.enrollmentViewModel.ISSINGLEGROUP === true) {
                //First day of the month
                let appdt = this.enrollmentViewModel.APPDT?.getDate()
                if (appdt !== 1) {
                    this.ErrorMessages.push('Application Date must be 1st day of the month prior to the Effective Date.')
                    this.hasError = true
                }
            }
        }
        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            this.effDate = new Date(this.enrollmentViewModel.EFFDT)
            let effDateVal = this.effDate.getDate()

            if (effDateVal != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }

            let effYearVal = this.effDate.getFullYear()

            if (effYearVal != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            if (this.enrollmentViewModel.FORMNAME !== 'EXTERNAL' && this.enrollmentViewModel.FORMNAME !== 'EXTERNALSMS') {
                let effectivedate = new Date(this.enrollmentViewModel.EFFDT)
                let applicationdate = new Date(this.enrollmentViewModel.APPDT || '')
                if (effectivedate <= applicationdate) {
                    this.ErrorMessages.push('Application date must be prior to the effective date.')
                    this.hasError = true
                }
            }
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }
        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Plan Type is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null) {
            this.ErrorMessages.push('Premium Payment is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (this.enrollmentViewModel.ACCHOLDERNAME === undefined || this.enrollmentViewModel.ACCHOLDERNAME === '') {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.EFTTYPE === undefined || this.enrollmentViewModel.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true
            }
            if (this.enrollmentViewModel.FININSTNAME === undefined || this.enrollmentViewModel.FININSTNAME === '') {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.ROUTINGNB === undefined || this.enrollmentViewModel.ROUTINGNB === '') {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkROUTINGNB = this.enrollmentViewModel.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollmentViewModel.ACCOUNTNB === undefined || this.enrollmentViewModel.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Secondary Coverage is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.OTHCVRG !== undefined && this.enrollmentViewModel.OTHCVRG.toString().toLowerCase() === 'yes') {
                if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                    this.ErrorMessages.push('Other Coverage Name is required')
                    this.hasError = true
                }
                if (
                    this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                    this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                    this.enrollmentViewModel.OTHCVRGNAME !== null
                ) {
                    let checkONAme = this.enrollmentViewModel.OTHCVRGNAME,
                        regexONameVal = /^[A-Za-z\s\-\' ]+$/
                    let isONAMEValid = regexONameVal.test(checkONAme)
                    if (!isONAMEValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Name is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGID !== undefined &&
                    this.enrollmentViewModel.OTHCVRGID !== '' &&
                    this.enrollmentViewModel.OTHCVRGID !== null
                ) {
                    let checkOID = this.enrollmentViewModel.OTHCVRGID,
                        regexOID = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOIDValid = regexOID.test(checkOID)
                    if (!isOIDValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage ID is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                    this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                    this.enrollmentViewModel.OTHCVRGGRP !== null
                ) {
                    let checkOTHCVRGGRP = this.enrollmentViewModel.OTHCVRGGRP,
                        regexOTHCVRGGRP = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isOGRPValid = regexOTHCVRGGRP.test(checkOTHCVRGGRP)
                    if (!isOGRPValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Other Coverage Group is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBBIN !== undefined &&
                    this.enrollmentViewModel.COBBIN !== '' &&
                    this.enrollmentViewModel.COBBIN !== null
                ) {
                    let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                        regexCOBBIN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBBINValid = regexCOBBIN.test(checkCOBBIN)
                    if (!isCOBBINValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoverageBIN is invalid')
                    }
                }
                if (
                    this.enrollmentViewModel.COBPCN !== undefined &&
                    this.enrollmentViewModel.COBPCN !== '' &&
                    this.enrollmentViewModel.COBPCN !== null
                ) {
                    let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                        regexCOBPCN = new RegExp('^[a-zA-Z0-9 ]*$')
                    let isCOBPCNValid = regexCOBPCN.test(checkCOBPCN)
                    if (!isCOBPCNValid) {
                        this.hasError = true
                        this.ErrorMessages.push('OtherCoveragePcn is invalid')
                    }
                }
            }
        }

        // 03-27-2020: Nitesh
        // Paperless settings configurable from the webconfig to turn it on and off
        if (!this.PaperlessOption) {
            if (!this.enrollmentViewModel.ISSINGLEGROUP) {
                if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB === '') {
                    this.ErrorMessages.push('EOB Preference is required')
                    this.hasError = true
                } else {
                    if (
                        this.enrollmentViewModel.EOB === undefined ||
                        this.enrollmentViewModel.EOB.toString().toLowerCase() == 'eeob' ||
                        this.enrollmentViewModel.EOB === '5' ||
                        this.enrollmentViewModel.EOB === '6' ||
                        this.enrollmentViewModel.EOB === '7' ||
                        this.enrollmentViewModel.EOB === '9'
                    ) {
                        if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
                            this.ErrorMessages.push('Email Address is required for Electronic Explanation of Benefits')
                            this.hasError = true
                        } else {
                            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                            if (!isOrgEmailValid) {
                                this.hasError = true
                                this.ErrorMessages.push('Email Address is invalid')
                            }
                        }
                    }
                    if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'peob') {
                        if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                            if (!isOrgEmailValid) {
                                this.hasError = true
                                this.ErrorMessages.push('Email Address is invalid')
                            }
                        }
                    }
                }
            } else {
                if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                    let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Email Address is invalid')
                    }
                }
            }
        } else {
            //if (!this.enrollmentViewModel.ISSINGLEGROUP) {
            if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB === '') {
                if (!this.enrollmentViewModel.ISSINGLEGROUP) {
                    this.enrollmentViewModel.EOB = 'PEOB'
                } else {
                    this.enrollmentViewModel.EOB = 'N'
                }
            }
            if (
                this.enrollmentViewModel.EOB === undefined ||
                this.enrollmentViewModel.EOB == '3' ||
                this.enrollmentViewModel.EOB.toString().toLowerCase() == 'eeob' ||
                this.enrollmentViewModel.EOB == '5' ||
                this.enrollmentViewModel.EOB == '6' ||
                this.enrollmentViewModel.EOB == '7' ||
                this.enrollmentViewModel.EOB == '9'
            ) {
                if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
                    this.ErrorMessages.push('Email Address is required for Paperless Documents')
                    this.hasError = true
                } else {
                    let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Email Address is invalid')
                    }
                }
            }
            if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB.toString().toLowerCase() === 'n') {
                if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                    let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()

                    let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                    if (!isOrgEmailValid) {
                        this.hasError = true
                        this.ErrorMessages.push('Email Address is invalid')
                    }
                }
            }
        }

        if (this.enrollmentViewModel.ISSINGLEGROUP && this.enrollmentViewModel.ISSTCOB) {
            if (this.enrollmentViewModel.SECMBRID == undefined || this.enrollmentViewModel.SECMBRID == '') {
                this.ErrorMessages.push('Secondary Member ID is required')
                this.hasError = true
            } else {
                let val = this.enrollmentViewModel.SECMBRID,
                    regexFNameVal = new RegExp('^[a-zA-Z. 0-9]*$')
                let isEmemValid = regexFNameVal.test(val)
                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Secondary Member ID is invalid')
                }
            }
            if (this.enrollmentViewModel.RELCD == undefined || this.enrollmentViewModel.RELCD == '') {
                this.ErrorMessages.push('RelationShip Code is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.FAMILYID == undefined || this.enrollmentViewModel.FAMILYID == '') {
                this.ErrorMessages.push('Family ID is required')
                this.hasError = true
            } else {
                let val = this.enrollmentViewModel.FAMILYID,
                    regexFNameVal = new RegExp('^[0-9]*$')
                if (this.enrollmentViewModel.ISSINGLEGROUP) {
                    regexFNameVal = new RegExp('^[a-zA-Z. 0-9]*$')
                }
                let isEmemValid = regexFNameVal.test(val)
                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Family ID is invalid')
                }
            }
            if (this.enrollmentViewModel.PERSONCD == undefined || this.enrollmentViewModel.PERSONCD == '') {
                this.ErrorMessages.push('Person Code is required')
                this.hasError = true
            } else {
                let val = this.enrollmentViewModel.PERSONCD,
                    regexFNameVal = new RegExp('^[0-9]*$')
                let isEmemValid = regexFNameVal.test(val)

                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Person Code is invalid')
                } else if (this.enrollmentViewModel.PERSONCD.length != 2) {
                    this.hasError = true
                    this.ErrorMessages.push('Person Code is invalid')
                }
            }
            if (this.enrollmentViewModel.APPEMAIL !== undefined && this.enrollmentViewModel.APPEMAIL !== '') {
                let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()
                let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
                if (!isOrgEmailValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Email Address is invalid')
                }
            }
        }

        if (this.enrollmentViewModel.ISSINGLEGROUP) {
            this.hasError = this.isValidDisenrllment()
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }
        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.MAILZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }

        if (
            this.enrollmentViewModel.CELLPHONE !== undefined &&
            this.enrollmentViewModel.CELLPHONE !== '' &&
            this.enrollmentViewModel.CELLPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.CELLPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('CellPhone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('CellPhone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }

        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === '') {
            this.ErrorMessages.push('Preferred Language is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.LTCPHONE !== undefined && this.enrollmentViewModel.LTCPHONE !== null) {
            let regexLTCVal = new RegExp('^[0-9]*$')
            if (this.enrollmentViewModel.LTCPHONE.length > 10 || !regexLTCVal.test(this.enrollmentViewModel.LTCPHONE)) {
                this.ErrorMessages.push('Long-Term Care Facility Phone must be exactly 10 numbers')
                this.hasError = true
            }
        }

        if (
            this.enrollmentViewModel.ELECTION === undefined ||
            this.enrollmentViewModel.ELECTION === null ||
            this.enrollmentViewModel.ELECTION === ''
        ) {
            this.ErrorMessages.push('Election Status is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null || this.enrollmentViewModel.HICN === '') {
            this.ErrorMessages.push('Medicare Number is required')
            this.hasError = true
        } else if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
        }

        /*
        if (this.enrollmentViewModel.CURRENTGENDER == "4" && (this.enrollmentViewModel.CURRENTGENDEROTH == undefined
            || this.enrollmentViewModel.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.GENDERNPRONOUN == "4" && (this.enrollmentViewModel.GENDERNPRONOUNOTH == undefined
            || this.enrollmentViewModel.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        */

        if (this.enrollmentViewModel.ISSINGLEGROUP && this.enrollmentViewModel.POVERIND !== '1' && this.enrollmentViewModel.APPADD1 !== '') {
            if (isPoBox(this.enrollmentViewModel.APPADD1)) {
                    this.ErrorMessages.push('Street Address cannot be a PO Box')
                    this.hasError = true
                }
            }

        if (this.enrollmentViewModel.ISSINGLEGROUP) {
            if (
                this.enrollmentViewModel.EXTERNALID !== undefined &&
                this.enrollmentViewModel.EXTERNALID !== '' &&
                this.enrollmentViewModel.EXTERNALID !== null
            ) {
                let val = this.enrollmentViewModel.EXTERNALID,
                    regexFNameVal = new RegExp('^[a-zA-Z. 0-9]*$')
                let isEmemValid = regexFNameVal.test(val)
                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('External Member ID  is invalid')
                }
            }
            if (
                this.enrollmentViewModel.CAREFAC !== undefined &&
                this.enrollmentViewModel.CAREFAC !== '' &&
                this.enrollmentViewModel.CAREFAC !== null
            ) {
                let val = this.enrollmentViewModel.CAREFAC,
                    regexFNameVal = new RegExp('^[a-zA-Z. 0-9]*$')
                let isEmemValid = regexFNameVal.test(val)
                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Care Facility is invalid')
                }
            }
            if (
                this.enrollmentViewModel.CAREQUAL !== undefined &&
                this.enrollmentViewModel.CAREQUAL !== '' &&
                this.enrollmentViewModel.CAREQUAL !== null
            ) {
                let val = this.enrollmentViewModel.CAREQUAL,
                    regexFNameVal = new RegExp('^[a-zA-Z. 0-9]*$')
                let isEmemValid = regexFNameVal.test(val)
                if (!isEmemValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Care Qualifier is invalid')
                }
            }
        }

        return this.hasError
    }

    private numberOfDaysDifference(disenrllDate: string, disenrllNoticeDate: string): number {
        //Get the number of miliseconds to cover the Daylight savings
        // It is calculating in UTC time zone
        //var oneDay = 1000 * 60 * 60 * 24
        //var disDateTime = new Date(disenrllDate).getTime()
        //var disNoticeDateTime = new Date(disenrllNoticeDate).getTime()

        //var numofDays = Math.abs(disDateTime - disNoticeDateTime)
        //return Math.round(numofDays / oneDay)

        var numofDaysDiff = moment.duration(moment.utc(disenrllDate).diff(moment.utc(disenrllNoticeDate))).asDays()
        return numofDaysDiff
    }

    private isValidDisenrllment(): boolean {
        if (
            this.enrollmentViewModel.DISENROLLIND === undefined ||
            this.enrollmentViewModel.DISENROLLIND === '' ||
            this.enrollmentViewModel.DISENROLLIND === '0'
        ) {
            this.ErrorMessages.push('Please select disenrollment and cancellation option')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.DISENROLLIND !== undefined && this.enrollmentViewModel.DISENROLLIND.toString().toLowerCase() === 'y') {
                if (this.enrollmentViewModel.DISENROLLDATE === undefined || this.enrollmentViewModel.DISENROLLDATE === null) {
                    this.ErrorMessages.push('Disenrollment/Cancellation effective date is required')
                    this.hasError = true
                }
                if (this.enrollmentViewModel.DISENROLLREASONCD === undefined || this.enrollmentViewModel.DISENROLLREASONCD === '') {
                    this.ErrorMessages.push('Disenrollment/Cancellation reason code is required')
                    this.hasError = true
                }

                //Last day of the month
                var disEnrEffDate = new Date(this.enrollmentViewModel.DISENROLLDATE)
                var disEnrEffDatelastDay = new Date(disEnrEffDate.getFullYear(), disEnrEffDate.getMonth() + 1, 0)

                //Retro enrollment logics for disenrollment effective date
                // 2 Months forward and 3 months backward
                if (this.enrollmentViewModel.DISENROLLDATE !== undefined && this.enrollmentViewModel.DISENROLLDATE !== null) {
                    var today = new Date()
                    var next2Month = new Date(today.setMonth(today.getMonth() + 2))
                    var next2MonthlastDay = new Date(next2Month.getFullYear(), next2Month.getMonth() + 1, 0)

                    var today = new Date()
                    var last3Month = new Date(today.setMonth(today.getMonth() - 3))
                    var last3MonthlastDay = new Date(last3Month.getFullYear(), last3Month.getMonth() + 1, 0)

                    if (disEnrEffDate.getTime() > next2MonthlastDay.getTime() || disEnrEffDate.getTime() < last3MonthlastDay.getTime()) {
                        this.ErrorMessages.push(
                            'Disenrollment/Cancellation effective date may only be up to 3 months back and 2 months forward from current date.'
                        )
                        this.hasError = true
                    }

                    //Remove the time from the disEnrEffDate
                    var condisEnrEffDate = new Date(this.enrollmentViewModel.DISENROLLDATE).toDateString()
                    var condisEnrEffDatenew = new Date(condisEnrEffDate)

                    if (condisEnrEffDatenew.getTime() !== disEnrEffDatelastDay.getTime()) {
                        this.ErrorMessages.push('Disenrollment/Cancellation Effective date must be last day of month.')
                        this.hasError = true
                    }
                }

                // Based on reason code check the disenrollment notice date
                // For Cancel (808) and Voluntary (810) the disenrollment notice date is required.
                // If disenrollment notice date is not passed then check the disenrollment effective date should be at least 30 days from todays date

                if (
                    this.enrollmentViewModel.DISENROLLREASONCD !== undefined &&
                    this.enrollmentViewModel.DISENROLLREASONCD !== null &&
                    this.enrollmentViewModel.DISENROLLREASONCD !== ''
                ) {
                    if (this.enrollmentViewModel.DISENROLLREASONCD === '808' || this.enrollmentViewModel.DISENROLLREASONCD === '810') {
                        if (this.enrollmentViewModel.DISENROLLNOTICEDT === undefined || this.enrollmentViewModel.DISENROLLNOTICEDT === null) {
                            this.ErrorMessages.push('Disenrollment/Cancellation date of Notice Sent is required')
                            this.hasError = true
                        } else {
                            if (this.enrollmentViewModel.DISENROLLDATE !== undefined && this.enrollmentViewModel.DISENROLLDATE !== null) {
                                if (this.enrollmentViewModel.DISENROLLNOTICEDT >= this.enrollmentViewModel.DISENROLLDATE) {
                                    this.ErrorMessages.push(
                                        'Disenrollment/Cancellation date of Notice Sent must be less then Effective Date of Disenrollment.'
                                    )
                                    this.hasError = true
                                }
                            }
                        }
                    } else {
                        //If no notice date is not provided it means they client wants us to provide the notice to the member,
                        //and the disenrollment date must be at least 30 day perspective from today�s date.
                        if (this.enrollmentViewModel.DISENROLLNOTICEDT === undefined || this.enrollmentViewModel.DISENROLLNOTICEDT === null) {
                            if (this.enrollmentViewModel.DISENROLLDATE !== undefined && this.enrollmentViewModel.DISENROLLDATE !== null) {
                                var today = new Date()
                                var nextMonth = new Date(today.setMonth(today.getMonth() + 1))
                                var nextMonthlastDay = new Date(nextMonth.getFullYear(), nextMonth.getMonth() + 1, 0)

                                if (disEnrEffDatelastDay.getTime() < nextMonthlastDay.getTime()) {
                                    this.ErrorMessages.push(
                                        'Disenrollment effective date must be at least 30 days from todays date and the last day of the month.'
                                    )
                                    this.hasError = true
                                }
                            }
                        } else {
                            var differenceDays = this.numberOfDaysDifference(
                                this.enrollmentViewModel.DISENROLLDATE,
                                this.enrollmentViewModel.DISENROLLNOTICEDT
                            )
                            var daysDiff = 30
                            if (differenceDays < daysDiff) {
                                this.ErrorMessages.push('Disenrollment/Cancellation Notice must be 30 days prior to the disenrollment date.')
                                this.hasError = true
                            }
                        }
                    }
                }
            }
        }
        return this.hasError
    }

    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }

    goBack(): void {
        this.enrollmentViewModel.ISBACK = true
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this.enrollmentViewModel !== undefined && this.enrollmentViewModel.ISSINGLEGROUP) {
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1/1/back'])
        } else if (this.enrollmentViewModel !== undefined && this.enrollmentViewModel.ISEXTERNALAGENT) {
            this.router.navigate([
                '/' + insCo + '/enrollment/external-agent/Step1/' + this.enrollmentViewModel.ACCESSKEY + '/' + this.enrollmentViewModel.ENROLLMENTID
            ])
        } else {
            this.router.navigate(['/' + insCo + '/enrollment/external-agent/Step1'])
        }
    }

    residentialAddressChanged(address: AddressDB) {
        this.residentialAddress = this.enrollmentViewModel.residentialAddress = address
        this.enrollmentViewModel.APPADD1 = address.addressLine1
        this.enrollmentViewModel.APPADD2 = address.addressLine2
        this.enrollmentViewModel.APPCITY = address.city
        this.enrollmentViewModel.APPST = address.state
        this.enrollmentViewModel.APPZIP = address.zip
        this.enrollmentViewModel.SAMEADDRESS = address.sameAddress
        this.enrollmentViewModel.POVERIND =
            address.poboxoverride === undefined || address.poboxoverride === null || address.poboxoverride === false ? '0' : '1'
    }

    mailingAddressChanged(address: AddressDB) {
        this.mailingAddress = this.enrollmentViewModel.mailingAddress = address
        this.enrollmentViewModel.MAILADD1 = address.addressLine1
        this.enrollmentViewModel.MAILADD2 = address.addressLine2
        this.enrollmentViewModel.MAILCITY = address.city
        this.enrollmentViewModel.MAILST = address.state
        this.enrollmentViewModel.MAILZIP = address.zip
        this.enrollmentViewModel.SAMEADDRESS = address.sameAddress
    }

    emailChanged(option: string) {
        this.enrollmentViewModel.APPEMAIL = option
    }
    sepdatechange(option: Date) {
        this.enrollmentViewModel.SEPEFFDT = option
    }

    ngOnDestroy() {
        this._enrollementGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }
    keyDownFunction(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.formSubmit()
        }
    }
}
